import { Box, Typography } from "@mui/material";
import { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import { City } from "../../constants/const";
import { SideNavLinks } from "../../constants/page";

import useCurrentTime from "../../hook/useCurrentTime";
import { convertDateTimeWithMinutes } from "../../utils/utils";

import { JailWhiteListPath } from "../../constants/jail";
import { getUserHelperBotInfo } from "../../reducers/game.slice";
import { useStyles } from "./SideBar.styles";
import useWallet from "../../hook/useWallet";

const SideBar = () => {
  const { classes } = useStyles();
  const currentTime = useCurrentTime();
  const dispatch = useAppDispatch();
  const { account } = useWallet();

  const { userTravelInfo, myProfile } = useAppSelector(
    (state) => state.profile
  );

  const {
    nextCrimeTime,
    jailedUntil,
    nextNickTime,
    nextTrainTime,
    userCarBotInfo,
    userBoozeBotInfo,
    userCrimeBotInfo,
    userKSBotInfo,
    userNarcsBotInfo,
    userBulletBotInfo,
    nextNarcsTime,
    nextBoozeTime,
    nextBulletBuyTime,
  } = useAppSelector((state) => state.game);

  const remainTimes: Record<string, any[]> = useMemo(() => {
    return {
      Crimes: [
        nextCrimeTime > currentTime
          ? convertDateTimeWithMinutes(nextCrimeTime - currentTime)
          : "Now",
        userCrimeBotInfo.isRunning ? "Bot" : "",
      ],

      "Nick a car": [
        nextNickTime > currentTime
          ? convertDateTimeWithMinutes(nextNickTime - currentTime)
          : "Now",
        userCarBotInfo.isRunning ? "Bot" : "",
      ],

      Travel: [
        userTravelInfo
          ? userTravelInfo?.travelUntil > currentTime
            ? convertDateTimeWithMinutes(
                userTravelInfo?.travelUntil - currentTime
              )
            : "Now"
          : "Now",
      ],
      Jail: [
        jailedUntil > currentTime
          ? convertDateTimeWithMinutes(jailedUntil - currentTime)
          : "Now",
      ],
      "Helper bots": [""],
      "Kill skill": [
        nextTrainTime > currentTime
          ? convertDateTimeWithMinutes(nextTrainTime - currentTime)
          : "Now",
        userKSBotInfo.isRunning ? "Bot" : "",
      ],
      Narcotics: [
        nextNarcsTime > currentTime
          ? convertDateTimeWithMinutes(nextNarcsTime - currentTime)
          : "Now",
        userNarcsBotInfo.isRunning ? "Bot" : "",
      ],
      Booze: [
        nextBoozeTime > currentTime
          ? convertDateTimeWithMinutes(nextBoozeTime - currentTime)
          : "Now",
        userBoozeBotInfo.isRunning ? "Bot" : "",
      ],
      "Bullet Factory": [
        nextBulletBuyTime > currentTime
          ? convertDateTimeWithMinutes(nextBulletBuyTime - currentTime)
          : "Now",
        userBulletBotInfo.isRunning ? "Bot" : "",
      ],
    };
  }, [
    nextCrimeTime,
    currentTime,
    userCrimeBotInfo.isRunning,
    nextNickTime,
    userCarBotInfo.isRunning,
    userTravelInfo,
    jailedUntil,
    nextTrainTime,
    userKSBotInfo.isRunning,
    nextNarcsTime,
    userNarcsBotInfo.isRunning,
    nextBoozeTime,
    userBoozeBotInfo.isRunning,
    nextBulletBuyTime,
    userBulletBotInfo.isRunning,
  ]);

  const isInJail = jailedUntil > currentTime;

  useEffect(() => {
    if (!account) return;

    dispatch(getUserHelperBotInfo(account));
  }, [account, dispatch]);

  return (
    <Box className={classes.sideBar}>
      {SideNavLinks.map((navLinks, index) => {
        return (
          <Box className={classes.navLinkGroup} key={index}>
            <Box className={classes.navLinkHeader}>
              <Box className={classes.navLinkHeaderContent}>
                <Box
                  component={"img"}
                  src={navLinks.icon}
                  className={classes.navLinkIcon}
                />
                <Typography className={classes.navLinkText}>
                  {navLinks.category === "LOCATION"
                    ? myProfile.city !== undefined
                      ? City[myProfile.city]
                      : "LOCATION"
                    : navLinks.category}
                </Typography>
              </Box>

              <Box className={classes.navLinkHeaderLine}></Box>
            </Box>

            <Box className={classes.navLinks}>
              {navLinks.subLinks.map((link, linkIndex) => {
                return (
                  <Link
                    to={
                      isInJail && JailWhiteListPath.indexOf(link.link) === -1
                        ? "/injail"
                        : navLinks.category === "LOCATION"
                        ? link.link + `/${myProfile.city || 0}`
                        : link.link
                    }
                    target={(link as any).target ?? "_self"}
                    className={classes.navLink}
                    key={linkIndex}
                  >
                    <Typography>{link.name}</Typography>
                    <Box className={classes.badgeList}>
                      {(link as any).showCooldown &&
                        remainTimes[link.name].map((time, index) => {
                          return time ? (
                            <Box
                              key={index}
                              className={
                                time === "Bot"
                                  ? classes.botBadge
                                  : time === "Now"
                                  ? classes.nowBadge
                                  : classes.timeBadge
                              }
                              sx={{
                                color:
                                  link.name === "Jail" && time !== "Now"
                                    ? "rgba(255, 0, 64, 0.78)!important"
                                    : "",
                              }}
                            >
                              {time ?? "Now"}
                            </Box>
                          ) : (
                            ""
                          );
                        })}
                    </Box>
                  </Link>
                );
              })}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default SideBar;
